import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ProductPage from './Pages/Product/ProductPage';
import PricingPage from './Pages/Pricing/PricingPage';
import ContactPage from './Pages/Contact/ContactPage';
import AboutPage from './Pages/About/AboutPage';
import BlogPage from './Pages/Blog/BlogPage';
import BlogPost from './Pages/BlogPost/BlogPost';

/* Define routes for the application */
const router = createBrowserRouter([
  {
    path: "/",
    element: <App/> /* Root path loads the main App component aka home page */
  },
  {
    path: "product",
    element: <ProductPage/> /* Loads the Product page */
  },
  {
    path: "pricing",
    element: <PricingPage/> /* Loads the Pricing page */
  },
  {
    path: "contact",
    element: <ContactPage/> /* Loads the Contact page */
  },
  {
    path: "about",
    element: <AboutPage/> /* Loads the About page */
  },
  {
    path: "blog",
    element: <BlogPage/> /* Loads the Blog page */
  },
  {
    path: "blog/:id",
    element: <BlogPost/> /* Loads individual Blog Post based on ID */
  }
]);

/* Initialize and render the root React component */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router = {router}/> 
  </React.StrictMode>
);
